<div class="info-box">
    <fa-icon class="info-box_icon" [icon]="icon"></fa-icon>
    <span class="info-box_title">{{title}}</span>
    <span class="info-box_body" id="textToCopy">{{text}}</span>
    <copy-button class="copy-btn" *ngIf="copy"></copy-button>
</div> 